<template>
  <v-card dark>
    <v-card-title v-if="props.title">
      {{ props.title }}
    </v-card-title>
    <v-card-subtitle>
      {{ value }}
    </v-card-subtitle>
    <v-card-text>
      <v-range-slider
        v-model="item"
        v-on:input="change"
        class="align-center black--text"
        :label="label"
        color="amber"
        :max="props.max"
        :min="props.min"
        thumb-label="always"
        hide-details
        thumb-color="amber"
        track-color="amber accent-1"
      ></v-range-slider>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
export default {
  name: "UnitRangeSlider",
  props: {
    props: {
      type: Object,
      default: null,
    },
    value: Number,
    label: String,
  },
  data() {
    return {
      item: this.value,
    };
  },
  watch: {
    item: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.item = val;
    },
  },
  methods: {
    change(ev) {
      console.log(ev);
      this.item = ev;
    },
  },
};
</script>

<style lang="scss"></style>
